import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=32ae28fb&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ae28fb')) {
      api.createRecord('32ae28fb', component.options)
    } else {
      api.reload('32ae28fb', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=32ae28fb&", function () {
      api.rerender('32ae28fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8LF8uzFnt2MuK/JS/pricelisthelp.vue"
export default component.exports